import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 16a8 8 0 01-7.72-5.93.48.48 0 01.13-.48.53.53 0 01.48-.13A6.99 6.99 0 009.45.9a.48.48 0 01.13-.48c.13-.13.31-.18.48-.13a8.01 8.01 0 015.93 7.72c0 4.41-3.59 8-8 8L8 16zm-6.49-5.39A7 7 0 008 15a7 7 0 002.61-13.49 7.98 7.98 0 01-9.1 9.1z" fill="#C2C2C2" /></svg>;